import { actionOn } from 'easy-peasy'

export const createShortcutsModel = initialData => ({
	data: _.cloneDeep(initialData.shortcuts || {}),
	onSuccessSingUp: actionOn(
		(actions, storeActions) => [
			storeActions.signUp.completeSingUp.successType,
			storeActions.signUp.updateSingUp.successType,
		],
		(state, { result: { shortcuts } }) => {
			state.data = shortcuts
		},
	),
})
